.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-width: var(--form-max);
}

.label {
  font: var(--t-body-strong);
  color: var(--ink);
}

.control {
  position: relative;
  display: flex;
  align-items: center;
}

.input {
  width: 100%;
  height: var(--control-height);
  padding: 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  font-variant-numeric: tabular-nums;
  transition: border-color var(--dur) var(--ease);
}

/* Widths by expected content (the `width` prop). Without it the field fills up to 720px. */
.field[data-width='xs'] {
  max-width: var(--field-xs);
}

.field[data-width='sm'] {
  max-width: var(--field-sm);
}

.field[data-width='md'] {
  max-width: var(--field-md);
}

.field[data-dense] .input {
  height: var(--control-height-dense);
}

.input::placeholder {
  color: var(--pencil);
}

.input[data-hovered] {
  border-color: var(--graphite);
}

.input[data-focused] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

/* Invalid: a 2px ink edge, so it reads as a problem and not as focus. */
.input[data-invalid] {
  border-color: var(--status-error-fg);
  outline: 1px solid var(--status-error-fg);
  outline-offset: -2px;
}

.input[data-disabled] {
  background: var(--wash);
  color: var(--pencil);
}

.field:has(.unit) .input {
  padding-right: var(--space-7);
}

.unit {
  position: absolute;
  right: var(--space-3);
  color: var(--graphite);
  font: var(--t-small);
  pointer-events: none;
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  color: var(--ink);
  font: var(--t-small);
  font-weight: 600;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
